<app-edtell-front-facing-dialog [config]="frontFacingDialogConfig">
    <app-step-one [dialogRef]="dialogRef" *ngIf="step == 1"></app-step-one>
    <app-step-two [dialogRef]="dialogRef" *ngIf="step == 2"></app-step-two>
    <app-step-three [dialogRef]="dialogRef" *ngIf="step == 3"></app-step-three>
    <app-step-four [dialogRef]="dialogRef" *ngIf="step == 4"></app-step-four>
    <app-step-five [dialogRef]="dialogRef" *ngIf="step == 5"></app-step-five>
</app-edtell-front-facing-dialog>